import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, LogIn, ArrowLeft } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error || "Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen bg-[#101827] text-white flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="text-xs text-white/60 hover:text-white inline-flex items-center gap-1 mb-6"><ArrowLeft className="w-3.5 h-3.5" /> Back to site</Link>
        <div className="flex items-center gap-2.5 mb-7">
          <div className="w-10 h-10 rounded-md bg-gradient-to-br from-[#C5A46D] to-[#8E7340] flex items-center justify-center">
            <span className="font-display font-bold text-[#101827] text-lg">A</span>
          </div>
          <div>
            <div className="font-bold tracking-wide">APURBA ESTATE</div>
            <div className="text-[11px] text-[#C5A46D] tracking-[0.2em] uppercase">Admin Panel</div>
          </div>
        </div>

        <div className="bg-white text-[#1F2937] rounded-2xl p-7">
          <h1 className="font-display text-2xl font-semibold text-[#101827]">Sign in to admin</h1>
          <p className="text-sm text-[#64748B] mt-1">Manage properties, leads, surveys and content.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]" />
              <input
                data-testid="admin-login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="w-full border border-[#E2E8F0] rounded-lg pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:border-[#183B66]"
              />
            </div>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]" />
              <input
                data-testid="admin-login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="w-full border border-[#E2E8F0] rounded-lg pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:border-[#183B66]"
              />
            </div>
            <button type="submit" disabled={loading} className="ae-btn-primary w-full justify-center" data-testid="admin-login-submit">
              <LogIn className="w-4 h-4" /> {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>

        <p className="text-xs text-white/50 mt-5 text-center">
          Access is restricted to authorised administrators.
        </p>
      </div>
    </div>
  );
}
